import { useTheme } from 'styled-components';

import { getNameLetters } from 'app/utils';
import formatDateFromUtcToTimezone from 'app/utils/formatDateFromUtcToTimezone';
import { Flex, RichContent, Typography } from 'components';
import {
  CommentList,
  CommentForm,
  CommentRow,
  CommentsItem,
  CommentsTypeEnum,
  useComments,
  CommentsReactionEnum,
  CommentsReactionItem,
  CommentsStatusEnum,
} from 'features/comments';
import { ReactionButton, ReactionIcon, ReplyButton, ReportButton } from './styles';

interface CommentProps {
  comment: CommentsItem;
  level: number;
  replying: boolean;
}

const Comment = ({ comment, level, replying }: CommentProps) => {
  const { currentTheme } = useTheme();

  const { setReplyingCommentUuid, sendReaction, setReportingCommentUuid } = useComments();

  const reactions = comment.reactions?.reduce((prev, reaction) => {
    const react = prev[reaction.reaction] || [];

    react.push(reaction);

    return { ...prev, [reaction.reaction]: react };
  }, {} as Record<CommentsReactionEnum, CommentsReactionItem[]>);

  const isApproved = comment.commentStatus === CommentsStatusEnum.Approved;

  return (
    <>
      <CommentRow level={level} letters={getNameLetters(comment.postedBy)}>
        <Flex flexGrow={0} justifyContent="space-between" pt={2} mb={2}>
          <Flex flexGrow={0} alignItems="flex-end">
            <Typography type="type3" fontWeight="bold" color="color100">
              {comment.postedBy}
            </Typography>

            <Typography type="type0" color="color50" ml={{ m: 3, d: 4 }}>
              {!!comment.postedAt ?? formatDateFromUtcToTimezone(comment.postedAt).format('DD/MM/YYYY HH[:]mm')}
            </Typography>
          </Flex>

          <ReportButton onClick={() => setReportingCommentUuid(comment.uuid)}>Denunciar</ReportButton>

          {/* <select
            onChange={(e: ChangeEvent<HTMLSelectElement>) => {
              if (window.confirm(`Você tem certeza que deseja reportar esse comentário?`)) {
                // sendReport(Number(e.target.value) as CommentsReportEnum);
              }
            }}
          >
            <option></option>
            
          </select> */}
        </Flex>

        <RichContent defaultType="type1" currentTheme={currentTheme}>
          {comment.text}
        </RichContent>

        <Flex justifyContent="space-between" mt={3}>
          <Flex flexGrow={0} alignItems="center">
            {!level && (
              <ReplyButton disabled={!isApproved} onClick={() => setReplyingCommentUuid(comment.uuid)}>
                Responder
              </ReplyButton>
            )}

            <ReactionButton disabled={!isApproved} onClick={() => sendReaction(comment.uuid, CommentsReactionEnum.Liked)}>
              <ReactionIcon icon="like" />
              {reactions[CommentsReactionEnum.Liked]?.length || 0}
            </ReactionButton>

            <ReactionButton disabled={!isApproved} onClick={() => sendReaction(comment.uuid, CommentsReactionEnum.Loved)}>
              <ReactionIcon icon="heart" />
              {reactions[CommentsReactionEnum.Loved]?.length || 0}
            </ReactionButton>
          </Flex>
        </Flex>

        {replying && (
          <Flex flexDirection="column" mt={3}>
            <CommentRow level={level + 1}>
              <CommentForm commentUuid={comment.uuid} commentType={CommentsTypeEnum.Answer} />
            </CommentRow>
          </Flex>
        )}

        {!!comment?.answers?.length && (
          <Flex flexDirection="column" mt={4}>
            <CommentList comments={comment?.answers} level={level + 1} />
          </Flex>
        )}
      </CommentRow>
    </>
  );
};

export default Comment;
